import * as React from 'react';

import type {User} from 'nutshell-core/types';

import {Popover} from 'shells/popover/popover';

import {AddNewCard} from './add-new-card';
import {getAddNewCards} from './helpers';

import styles from './add-new-popover.module.css';

type Props = {
    addNewRef: any;
    setIsCreateNewActive: (isActive: boolean) => void;
    user: User | null | undefined;
};

export function AddNewPopover(props: Props) {
    const containerRef = React.useRef(null);

    // Focus the container div instead of the first card when mounted
    React.useEffect(() => {
        if (containerRef.current) {
            // @ts-expect-error
            containerRef.current.focus();
        }
    }, []);

    const cards = getAddNewCards(props.user ? props.user.permissions.canUseSalesDocuments : false);

    return (
        <Popover
            onBlur={() => props.setIsCreateNewActive(false)}
            // @ts-expect-error
            placement='bottom-left'
            hideNub={true}
            anchor={props.addNewRef.current}
            disableFocusTrapZone={true}
        >
            <div ref={containerRef} tabIndex={-1} className={styles['add-new-popover-container']}>
                {cards.map((card) => (
                    <AddNewCard
                        key={card.title}
                        icon={card.icon}
                        iconColor={card.iconColor}
                        title={card.title}
                        description={card.description}
                        to={card.to}
                        isModalLink={card.isModalLink}
                        onClick={() => props.setIsCreateNewActive(false)}
                    />
                ))}
            </div>
        </Popover>
    );
}
